// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-detail-page {
  min-height: 100vh;
  background: #f5f7fa;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.analysis-detail-page .app-header {
  margin-bottom: 0;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 40px;
}

.detail-header {
  margin-bottom: 30px;
}

.detail-header h1 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  font-size: 32px;
  color: #333;
  margin: 15px 0;
  min-width: 0;
}

.detail-action-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.back-button {
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.back-button:hover {
  text-decoration: underline;
}

.interactive-view-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.interactive-view-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.interactive-view-button:active {
  transform: translateY(0);
}

.analysis-information-card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.analysis-information-card h2 {
  font-size: 20px;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.analysis-subtitle {
  font-size: 16px;
  color: #667eea;
  font-weight: 600;
  margin-left: 8px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 13px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  color: #333;
  word-break: break-word;
}

.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  width: fit-content;
}

.status-finished,
.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-running,
.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-failed {
  background: #f8d7da;
  color: #721c24;
}

.results-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.results-section h2 {
  font-size: 20px;
  color: #333;
  margin: 0 0 25px 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
}

.result-card {
  background: #f9f9f9;
  border-radius: 10px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.result-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.result-image-wrapper {
  width: 100%;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.result-image {
  width: 100%;
  height: auto;
  display: block;
}

.result-caption {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  word-break: break-word;
}

.view-full-link {
  color: #667eea;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.view-full-link:hover {
  text-decoration: underline;
}

.result-file-link {
  padding: 20px;
  text-align: center;
}

.result-file-link a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
}

.result-file-link a:hover {
  text-decoration: underline;
}

.report-section {
  background: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  margin-bottom: 0 !important;
}

/* Validation Results Section */
.validation-results-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.validation-results-section h2 {
  font-size: 22px;
  color: #333;
  margin: 0 0 15px 0;
}

.validation-meta {
  font-size: 14px;
  color: #666;
  margin: 5px 0;
}

.validation-table-wrapper {
  margin-top: 20px;
  overflow-x: auto;
}

.validation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.validation-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.validation-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.validation-table td {
  padding: 10px 16px;
  border-bottom: 1px solid #e9ecef;
  color: #333;
}

.validation-table tbody tr:hover {
  background: #f8f9fa;
}

.validation-table a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.validation-table a:hover {
  text-decoration: underline;
}

.table-truncation-note {
  margin-top: 15px;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  font-size: 13px;
  color: #856404;
  text-align: center;
}

.error-message {
  background: #fef5f5;
  color: #e74c3c;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid #fcc;
  font-size: 15px;
  margin-bottom: 20px;
}

/* Analysis Title Edit Styles */
.analysis-title-edit {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.analysis-title-input {
  flex: 0 0 420px;
  padding: 12px 16px;
  border: 2px solid #667eea;
  border-radius: 8px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  outline: none;
  width: 420px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}

.analysis-title-input:focus {
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);
}

.title-save-btn,
.title-cancel-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.title-save-btn {
  background: #4caf50;
  color: white;
}

.title-save-btn:hover {
  background: #43a047;
}

.title-cancel-btn {
  background: #f0f0f0;
  color: #666;
}

.title-cancel-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.analysis-title-text {
  display: inline-block;
  max-width: min(100%, 900px);
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  cursor: pointer;
  transition: color 0.2s;
}

.analysis-title-text:hover {
  color: #667eea;
}

.title-rename-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 4px 8px;
  opacity: 0.4;
  transition: opacity 0.2s;
  vertical-align: middle;
}

.detail-header h1 .title-rename-btn {
  flex: 0 0 auto;
}

.detail-header h1 .analysis-title-text {
  flex: 0 1 auto;
}

.detail-header h1 .analysis-title-text:hover {
  animation: analysis-title-scroll 8s linear infinite alternate;
}

@keyframes analysis-title-scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(calc(-1 * max(0px, 100% - 100%)));
  }
}

.title-rename-btn:hover {
  opacity: 1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .results-grid {
    grid-template-columns: 1fr;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .analysis-title-input {
    font-size: 20px;
    padding: 10px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/AnalysisDetailPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".analysis-detail-page {\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.analysis-detail-page .app-header {\n  margin-bottom: 0;\n}\n\n.detail-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 100px 20px 40px;\n}\n\n.detail-header {\n  margin-bottom: 30px;\n}\n\n.detail-header h1 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  font-size: 32px;\n  color: #333;\n  margin: 15px 0;\n  min-width: 0;\n}\n\n.detail-action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #667eea;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.back-button:hover {\n  text-decoration: underline;\n}\n\n.interactive-view-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.interactive-view-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.interactive-view-button:active {\n  transform: translateY(0);\n}\n\n.analysis-information-card {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.analysis-information-card h2 {\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 20px 0;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.analysis-subtitle {\n  font-size: 16px;\n  color: #667eea;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.info-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.info-label {\n  font-size: 13px;\n  color: #666;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 15px;\n  color: #333;\n  word-break: break-word;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  width: fit-content;\n}\n\n.status-finished,\n.status-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-running,\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-failed {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.results-section {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.results-section h2 {\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 25px 0;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 25px;\n}\n\n.result-card {\n  background: #f9f9f9;\n  border-radius: 10px;\n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.result-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.result-image-wrapper {\n  width: 100%;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.result-image {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.result-caption {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 8px;\n  word-break: break-word;\n}\n\n.view-full-link {\n  color: #667eea;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.view-full-link:hover {\n  text-decoration: underline;\n}\n\n.result-file-link {\n  padding: 20px;\n  text-align: center;\n}\n\n.result-file-link a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.result-file-link a:hover {\n  text-decoration: underline;\n}\n\n.report-section {\n  background: none;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n  margin-bottom: 0 !important;\n}\n\n/* Validation Results Section */\n.validation-results-section {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.validation-results-section h2 {\n  font-size: 22px;\n  color: #333;\n  margin: 0 0 15px 0;\n}\n\n.validation-meta {\n  font-size: 14px;\n  color: #666;\n  margin: 5px 0;\n}\n\n.validation-table-wrapper {\n  margin-top: 20px;\n  overflow-x: auto;\n}\n\n.validation-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.validation-table thead {\n  background: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.validation-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  white-space: nowrap;\n}\n\n.validation-table td {\n  padding: 10px 16px;\n  border-bottom: 1px solid #e9ecef;\n  color: #333;\n}\n\n.validation-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.validation-table a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.validation-table a:hover {\n  text-decoration: underline;\n}\n\n.table-truncation-note {\n  margin-top: 15px;\n  padding: 12px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #856404;\n  text-align: center;\n}\n\n.error-message {\n  background: #fef5f5;\n  color: #e74c3c;\n  padding: 16px 20px;\n  border-radius: 8px;\n  border: 1px solid #fcc;\n  font-size: 15px;\n  margin-bottom: 20px;\n}\n\n/* Analysis Title Edit Styles */\n.analysis-title-edit {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.analysis-title-input {\n  flex: 0 0 420px;\n  padding: 12px 16px;\n  border: 2px solid #667eea;\n  border-radius: 8px;\n  font-size: 28px;\n  font-weight: 600;\n  color: #333;\n  outline: none;\n  width: 420px;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n\n.analysis-title-input:focus {\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);\n}\n\n.title-save-btn,\n.title-cancel-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.title-save-btn {\n  background: #4caf50;\n  color: white;\n}\n\n.title-save-btn:hover {\n  background: #43a047;\n}\n\n.title-cancel-btn {\n  background: #f0f0f0;\n  color: #666;\n}\n\n.title-cancel-btn:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.analysis-title-text {\n  display: inline-block;\n  max-width: min(100%, 900px);\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.analysis-title-text:hover {\n  color: #667eea;\n}\n\n.title-rename-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 4px 8px;\n  opacity: 0.4;\n  transition: opacity 0.2s;\n  vertical-align: middle;\n}\n\n.detail-header h1 .title-rename-btn {\n  flex: 0 0 auto;\n}\n\n.detail-header h1 .analysis-title-text {\n  flex: 0 1 auto;\n}\n\n.detail-header h1 .analysis-title-text:hover {\n  animation: analysis-title-scroll 8s linear infinite alternate;\n}\n\n@keyframes analysis-title-scroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(calc(-1 * max(0px, 100% - 100%)));\n  }\n}\n\n.title-rename-btn:hover {\n  opacity: 1;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .results-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .analysis-title-input {\n    font-size: 20px;\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
